import { defineStore } from 'pinia';
import axios from 'axios';
import { useAuthStore } from '@/store/global/auth';
import { useMarketStore } from '@/store/global/market';
import { useProfileStore } from '@/store/global/profile';

export const useAdminStore = defineStore('admin', {
	state: () => ({
        selectedUser: null,
		loggedAs: false,
	}),
	actions: {
		async connectAS(user_id) {
			const response = await axios.post('/login-as', {
					user_id: user_id,
				},
				{ withCredentials: true },
			);

			if (response.data.token) {
				const authStore = useAuthStore();
				const marketStore = useMarketStore();
				const profileStore = useProfileStore();

				marketStore.selectedProject = response.data.project_id;
				marketStore.selectedMarket = response.data.market_id;

				authStore.setDecodedToken(response.data.token);
				authStore.is_staff = response.data.is_staff || false;

				await authStore.storeUser();
				await profileStore.fetchData();

				this.selectedUser = null;

				this.loggedAs = true;
				return true;
			}

			return false;
		},
		async ConnectBack() {

			const response = await axios.post('/login-back', {},
				{ withCredentials: true },
			);

			if (response.data.token) {
				const authStore = useAuthStore();
				const profileStore = useProfileStore();

				authStore.setDecodedToken(response.data.token);
				authStore.is_staff = response.data.is_staff || false;

				await authStore.storeUser();
				await profileStore.fetchData();

				this.selectedUser = null;

				this.loggedAs = false;
				return true;
			}

			return false;
		}
	},
	persist: true,
});
